const renderAdnimation = () => {
  const zones = document.querySelectorAll("[data-zone-adnimation]")
  if (zones.length == 0) return

  if (window.adn) window.adn.cmd.push(window.adn.destroy)

  zones.forEach((zone) => {
    const div = document.createElement("div")
    div.setAttribute("data-aaad", "true")
    div.setAttribute("data-aa-adunit", zone.dataset.zoneAdnimation)
    zone.appendChild(div)
  })

  if (window.adn) {
    window.adn.cmd.push(window.adn.processAdsOnPage)
  } else {
    insertAdnimation()
    insertConfiant()
  }
}

const insertAdnimation = () => {
  window.adn = { "cmd": [] }

  const script = document.createElement("script")
  script.setAttribute("async", "async")
  script.src = "https://adncdnend.azureedge.net/adn-hb/adn.c3d.js"
  document.head.appendChild(script)
}

const insertConfiant = () => {
  const id = "d2ehZtyVAa1kXxOtMxFp7XciXcU"
  window.confiant = window.confiant || {}
  window.confiant[id] = window.confiant[id] || { clientSettings: {} }
  const clientSettings =
    window.confiant[id].clientSettings ||
    (window.confiant[id].clientSettings = {})
  clientSettings.prebidExcludeBidders = ["criteo", "sharethrough"]

  const script = document.createElement("script")
  script.setAttribute("async", "async")
  script.src =
    `https://cdn.confiant-integrations.net/${id}/gpt_and_prebid/config.js`

  document.head.appendChild(script)
}

export { renderAdnimation }
